import React, { useState } from "react";
import styles from "./Landing.module.css";
import appStoreSvg from "../../assets/appstore.svg";
// import googlePlaySvg from "../../assets/googleplay.svg";
import one from "../../assets/one.png";
import two from "../../assets/two.png";
import three from "../../assets/three.png";
import person1 from "../../assets/person1.jpg";
import person2 from "../../assets/person2.jpg";
import person3 from "../../assets/person3.jpg";

export const Landing = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage("");

    try {
      const formData = new FormData(e.target);

      const response = await fetch("https://getform.io/f/adrdndea", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        setSubmitMessage(
          "Thank you for reaching out! We'll get back to you soon to help with your coding journey."
        );
        setFormData({ name: "", email: "", message: "" });
      } else {
        throw new Error("Form submission failed");
      }
    } catch (error) {
      setSubmitMessage(
        "Sorry, there was an error sending your message. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.container}>
      <header className={styles.nav}>
        <h1 className={styles.navTitle}>Leetly</h1>
        <a
          href="https://apps.apple.com/us/app/leetly-land-a-swe-job/id6752914609"
          className={styles.downloadButton}
          aria-label="Download"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg
            className={styles.landingSvg}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 256 256"
            focusable="false"
          >
            <g weight="regular">
              <path d="M240,136v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V136a16,16,0,0,1,16-16H72a8,8,0,0,1,0,16H32v64H224V136H184a8,8,0,0,1,0-16h40A16,16,0,0,1,240,136Zm-117.66-2.34a8,8,0,0,0,11.32,0l48-48a8,8,0,0,0-11.32-11.32L136,108.69V24a8,8,0,0,0-16,0v84.69L85.66,74.34A8,8,0,0,0,74.34,85.66ZM200,168a12,12,0,1,0-12,12A12,12,0,0,0,200,168Z" />
            </g>
          </svg>
          <span className={styles.downloadButtonText}>Download</span>
        </a>
      </header>

      <main className={styles.hero}>
        <h1 className={styles.title}>
          Master LeetCode
          <br /> Ace Your Interviews
        </h1>
        <p className={styles.description}>
          The gamified mobile app that transforms LeetCode practice into an
          engaging journey. Master algorithms, ace technical interviews, and
          land your dream job.
        </p>

        <div className={styles.storeButtons}>
          <a
            href="https://apps.apple.com/us/app/leetly-land-a-swe-job/id6752914609"
            className={styles.appStoreButton}
            aria-label="App Store"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={appStoreSvg}
              alt="App Store"
              className={styles.storeImage}
            />
          </a>
          {/* <a
            href="https://play.google.com/store/apps/details?id=com.apps.leetly"
            className={styles.playStoreButton}
            aria-label="Google Play"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={googlePlaySvg}
              alt="Google Play"
              className={styles.storeImage}
            />
          </a> */}
        </div>

        <a
          href="https://apps.apple.com/us/app/leetly-land-a-swe-job/id6752914609"
          className={styles.joinButtonLink}
        >
          <button className={styles.joinButton}>START LEARNING</button>
        </a>
      </main>

      <section className={styles.features}>
        <h2 className={styles.subtitle}>
          How Leetly Helps You Master Data Structures & Algorithms
        </h2>

        <div className={styles.featureRow}>
          <img
            src={one}
            alt="Practice Problems"
            className={styles.featureImg}
          />
          <div className={styles.featureText}>
            <h3 className={styles.featureTitle}>Customized Learning Path</h3>
            <p className={styles.featureDesc}>
              Solve coding problems step-by-step with guided explanations and
              track your progress as you master different algorithms and data
              structures.
            </p>
          </div>
        </div>

        <div className={styles.featureRowReverse}>
          <img
            src={two}
            alt="Gamified Learning"
            className={styles.featureImg}
          />
          <div className={styles.featureText}>
            <h3 className={styles.featureTitle}>Practice LeetCode Problems</h3>
            <p className={styles.featureDesc}>
              Solve coding problems step-by-step with guided explanations and
              track your progress as you master different algorithms and data
              structures.
            </p>
          </div>
        </div>

        <div className={styles.featureRow}>
          <img src={three} alt="Interview Prep" className={styles.featureImg} />
          <div className={styles.featureText}>
            <h3 className={styles.featureTitle}>
              Stay Ahead of the Competition
            </h3>
            <p className={styles.featureDesc}>
              Practice real interview questions from top tech companies and get
              instant feedback to know exactly where you stand.
            </p>
          </div>
        </div>
      </section>

      <section className={styles.testimonialsSection}>
        <div className={styles.testimonialsHeader}>
          <span className={styles.testimonialsLabel}>Success stories</span>
          <h2 className={styles.testimonialsTitle}>
            Thousands of developers have landed their dream jobs,
            <span className={styles.highlight}>
              {" "}
              and there's a good reason.
            </span>
          </h2>
          <p className={styles.testimonialsSub}>
            Developers have transformed their careers with Leetly — from
            struggling with algorithms to acing FAANG interviews.
          </p>
        </div>

        <div className={styles.testimonialsGrid}>
          {[person1, person2, person3].map((src, i) => {
            const quotes = [
              `"I'd struggled with LeetCode for months, but nothing clicked—until
              Leetly. The gamified approach and step-by-step explanations kept me
              motivated. I just landed a software engineer role at Google,
              and I finally feel confident in my coding skills."`,
              `"Leetly's structured learning path changed everything.
              Algorithms used to intimidate me—I'd avoid them completely.
              Now I tackle dynamic programming problems with confidence.
              I've never felt this prepared for technical interviews."`,
              `"Cracking coding interviews felt impossible—I'd fail every time.
              Leetly's mock interviews and instant feedback gave me the push I
              needed. My problem-solving speed improved 300%, and I'm now
              working at my dream startup."`,
            ];
            const names = ["Alex Chen", "Sarah Kim", "Michael Rodriguez"];
            return (
              <div key={i} className={styles.card}>
                <p className={styles.cardText}>{quotes[i]}</p>
                <div className={styles.cardFooter}>
                  <img src={src} alt={names[i]} className={styles.avatar} />
                  <div>
                    <p className={styles.author}>{names[i]}</p>
                    <p className={styles.role}>Software Engineer</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className={styles.contactSection}>
        <div className={styles.contactContainer}>
          <div className={styles.contactHeader}>
            <h2 className={styles.contactTitle}>Get in Touch</h2>
            <p className={styles.contactSubtitle}>
              Have questions about Leetly or need help with your coding journey?
              Fill out the form and our team will get back to you within 24
              hours.
            </p>
            <div className={styles.contactEmail}>
              <svg
                className={styles.emailIcon}
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
              </svg>
              <span>team@originapps.dev</span>
            </div>
          </div>

          <form className={styles.contactForm} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="name" className={styles.formLabel}>
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleInputChange}
                className={styles.formInput}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="email" className={styles.formLabel}>
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                className={styles.formInput}
                required
                disabled={isSubmitting}
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="message" className={styles.formLabel}>
                Message
              </label>
              <textarea
                id="message"
                name="message"
                placeholder="Message..."
                value={formData.message}
                onChange={handleInputChange}
                className={styles.formTextarea}
                rows="5"
                required
                disabled={isSubmitting}
              ></textarea>
            </div>

            {submitMessage && (
              <div className={styles.submitMessage}>{submitMessage}</div>
            )}

            <button
              type="submit"
              className={styles.sendButton}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};
